import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { notesShape } from 'constants/propTypes';
import { ActionButton } from 'components/ui/Button';
import { useManagedMutation } from 'utils/managedHooks';
import { ADD_NOTE_TO_BOOKING } from 'store/mutations';

import NoteDetail from 'components/shared/NoteDetail';

import { StyledForm, StyledTextArea, DetailsContainer } from './NoteDetails.styles';

const NoteDetails = ({ bookingReference, notes }) => {
  const [note, setNote] = useState('');
  const [isOpen, toggleForm] = useState(false);
  const [addNote, { loading }] = useManagedMutation(ADD_NOTE_TO_BOOKING);

  const handleLinkToggle = () => toggleForm(true);
  const handleTextChange = (event) => setNote(event.target.value);
  const handleFormSubmit = async () => {
    await addNote({
      variables: {
        note,
        bookingReference
      }
    });

    setNote('');
    toggleForm(false);
  };

  const isSubmitDisabled = note.match(/^\s*$/);

  const notesByRevisionNumber = [...notes].sort((a, b) => b.revisionNumber - a.revisionNumber);

  return (
    <>
      {!isOpen && (
        <div>
          <ActionButton data-cy="notes-add-new-link" onClick={handleLinkToggle}>
            <FormattedMessage id="notes.new" />
          </ActionButton>
        </div>
      )}

      {isOpen && (
        <StyledForm onSubmit={handleFormSubmit}>
          <StyledTextArea name="note" value={note} onChange={handleTextChange} required data-cy="notes-add-new-text" disabled={loading} />
          <ActionButton data-cy="notes-add-new-submit" loading={loading} disabled={isSubmitDisabled}>
            <FormattedMessage id="notes.add" />
          </ActionButton>
        </StyledForm>
      )}

      <DetailsContainer>
        {notesByRevisionNumber.map((noteDetail) => (
          <NoteDetail key={noteDetail.uuid} detail={noteDetail} />
        ))}
      </DetailsContainer>
    </>
  );
};

NoteDetails.propTypes = {
  bookingReference: PropTypes.string.isRequired,
  notes: notesShape.isRequired
};

export default NoteDetails;
